import React, { useState, useEffect } from "react";
import {  Table, } from 'react-bootstrap';

import './RegisteredEmployees.css';
import { Link } from "react-router-dom";
const EmployeesRegistered = () => {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/report/employees/all`);
        const data = await response.json(); // Assuming the API returns JSON
        setEmployees(data); // Store the data in state
      } catch (error) {
        console.error('Error fetching employee data:', error);
      }
    };

    fetchEmployeeData();
  }, []);
  return (
    <>

      <div className="registered-employees-page-main">


        <div className="registered-employees-head">Employees Details </div>

        <div className="registered-employees-page">
          <div className=" registered-employees">
            {/* <PerfectScrollbar> */}
              <Table responsive>
                <thead>
                  <tr>
                   <th>
                      <span>S.No</span>
                    </th>
                    <th>
                      <span>Employee Id</span>
                    </th>
                    <th>
                      <span>Present District</span>
                    </th>
                    <th>
                      <span>Employee Name</span>
                    </th>
                    <th>
                      <span>Phone Number</span>
                    </th>
                    <th>
                      <span>Email</span>
                    </th>
                    <th>Report</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((employee, index) => (
                    <tr key={index}>
                    <td>{index+1}</td>
                      <td>{employee.employeeId}</td>
                      <td>{employee.presentDistrict}</td>
                      <td>{employee.employeeName}</td>
                      <td>{employee.contactNumber}</td>
                      <td>{employee.emailAddress}</td>
                      <td>
                        <Link
                          to='/detailsofemployee'
                          onClick={() => localStorage.setItem('selectedEmployeeId', employee.employeeId)}
                        >
                          View
                        </Link>
                        {/* <Link
                          to="/cmrViewReport"
                          onClick={() =>
                            handleViewReportClick(

                              data.godownId,
                              data.startTime,
                              data.username,
                            )
                          }
                          target="_blank" // Open in a new tab
                          rel="noopener noreferrer" // For security reasons (to prevent vulnerabilities)
                        >
                          View Report
                        </Link> */}
                      </td>

                    </tr>
                  ))}
                </tbody>
              </Table>
            {/* </PerfectScrollbar> */}
          </div>
        </div>

      </div>

    </>
  )
}
export default EmployeesRegistered;